import { requireTranslations } from '../../../common/translation';

export default requireTranslations((locale: string) => require(`./browser-notice.${locale}.json`));
